import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Loader2, CheckCircle2 } from "lucide-react";

const field = "w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 outline-none focus:border-primary/50";

// Used for BOTH /reset-password (password reset) and /set-password (super-admin bootstrap) — same endpoint.
export default function SetPassword({ bootstrap = false }) {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("Les mots de passe ne correspondent pas");
    if (pw.length < 6) return setError("Au moins 6 caractères");
    setLoading(true); setError("");
    try {
      await api.post("/auth/set-password", { token, password: pw });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[hsl(var(--surface))]/90 p-8">
        <Link to="/" className="font-heading text-2xl font-black tracking-tight">Vytali<span className="text-primary">Flix</span></Link>
        <h1 className="mt-6 font-heading text-2xl font-bold">{bootstrap ? "Activer mon compte Super Admin" : "Nouveau mot de passe"}</h1>
        {!token ? (
          <p className="mt-4 text-sm text-destructive">Lien invalide (jeton manquant).</p>
        ) : done ? (
          <div className="mt-6 flex flex-col items-center gap-3 text-center" data-testid="setpw-done">
            <CheckCircle2 className="h-12 w-12 text-primary" />
            <p className="text-sm text-muted-foreground">Mot de passe défini avec succès.</p>
            <Link to="/login" className="rounded-full bg-primary px-6 py-2.5 font-semibold text-primary-foreground">Se connecter</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input type="password" required placeholder="Nouveau mot de passe" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="setpw-password" className={field} />
            <input type="password" required placeholder="Confirmer le mot de passe" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="setpw-confirm" className={field} />
            {error && <p className="text-sm text-destructive" data-testid="setpw-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="setpw-submit" className="flex w-full items-center justify-center gap-2 rounded-lg bg-primary py-3 font-semibold text-primary-foreground disabled:opacity-60">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Valider
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
